import { Link } from "@tanstack/react-router"

import { Button } from "@/components/ui/button"
import { Card, CardTitle } from "@/components/ui/card"

export function HomeNewClientCard() {
  return (
    <Card className="@container min-w-0 overflow-hidden p-6">
      <div className="grid h-full grid-cols-1 grid-rows-[auto_1fr] gap-4 @md:grid-cols-[1fr_auto]">
        <CardTitle className="leading-tight @md:col-span-2">
          Add a New Client
        </CardTitle>

        <div className="flex flex-col justify-between">
          <p className="mb-4">
            Easily start a new funding request on behalf of a client for their
            business financial needs.
          </p>
          <Button className="bg-primary self-start" asChild>
            <Link to="/partners/companies/add">Add</Link>
          </Button>
        </div>
      </div>
    </Card>
  )
}
